import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Zone } from '@app/shared/models';
import { TableService } from '@app/shared/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-zone-selector',
  templateUrl: './zone-selector.component.html',
  styleUrls: ['./zone-selector.component.scss']
})
export class ZoneSelectorComponent implements OnInit, OnDestroy, OnChanges {
  @Input() zones: Zone[] = [];
  @Input() selectedZoneId: string | null = null;
  @Input() canCreate = true;
  @Input() canEdit = true;
  @Output() zoneSelected = new EventEmitter<string>();
  @Output() createZone = new EventEmitter<void>();
  @Output() deleteZone = new EventEmitter<Zone>();

  zoneTableCounts: Map<string, number> = new Map();
  private destroy$ = new Subject<void>();

  constructor(
    private tableService: TableService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Suscribirse a cambios en las mesas para actualizar los conteos
    this.tableService.tables$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateZoneCounts();
        this.cdr.markForCheck();
      });

    // Inicializar conteos
    this.updateZoneCounts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Actualizar conteos cuando cambien las zonas
    if (changes['zones'] && this.zones && this.zones.length > 0) {
      this.updateZoneCounts();
      this.cdr.markForCheck();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateZoneCounts(): void {
    this.zones.forEach(zone => {
      const count = this.tableService.getTablesByZone(zone.id).length;
      this.zoneTableCounts.set(zone.id, count);
    });
  }

  selectZone(zoneId: string): void {
    if (this.selectedZoneId !== zoneId) {
      this.zoneSelected.emit(zoneId);
    }
  }

  onCreateZone(): void {
    this.createZone.emit();
  }

  onDeleteZone(zone: Zone): void {
    this.deleteZone.emit(zone);
  }

  getZoneIcon(type: string): string {
    const icons: Record<string, string> = {
      'PISO': 'fa-building',
      'SALA': 'fa-utensils',
      'TERRAZA': 'fa-umbrella-beach',
      'BARRA': 'fa-cocktail',
      'VIP': 'fa-star',
    };
    return icons[type] || 'fa-map-marker-alt';
  }

  getZoneTableCount(zoneId: string): number {
    return this.zoneTableCounts.get(zoneId) || 0;
  }
}
